import React from 'react';
import { SvgIcon } from '@mui/material';

function ScheduleIcon({ ...props }) {
  return (
    <SvgIcon {...props} viewBox="0 0 128 118">
      <path
        d="M113.64 13.1599H84.3199V4.40991C84.3199 2.33991 82.6399 0.659912 80.5699 0.659912C78.4999 0.659912 76.8199 2.33991 76.8199 4.40991V13.1599H49.8399V4.40991C49.8399 2.33991 48.1599 0.659912 46.0899 0.659912C44.0199 0.659912 42.3399 2.33991 42.3399 4.40991V13.1599H42.2899V20.6599H42.3399V28.5199C42.3399 30.5899 44.0199 32.2699 46.0899 32.2699C48.1599 32.2699 49.8399 30.5899 49.8399 28.5199V20.6599H76.8199V28.5199C76.8199 30.5899 78.4999 32.2699 80.5699 32.2699C82.6399 32.2699 84.3199 30.5899 84.3199 28.5199V20.6599H113.64C117.07 20.6599 119.85 23.4499 119.85 26.8699V47.3299H8.1499V26.8699C8.1499 23.4399 10.9399 20.6599 14.3599 20.6599H34.7699V13.1599H14.3599C6.7999 13.1599 0.649902 19.3099 0.649902 26.8699V103.63C0.649902 111.19 6.7999 117.34 14.3599 117.34H113.63C121.19 117.34 127.34 111.19 127.34 103.63V26.8699C127.34 19.3099 121.19 13.1599 113.63 13.1599H113.64ZM119.85 103.64C119.85 107.07 117.06 109.85 113.64 109.85H14.3599C10.9299 109.85 8.1499 107.06 8.1499 103.64V54.8399H119.85V103.64Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export default ScheduleIcon;
